export enum CardType {
  AG = 176,
  AffDeposit = 97,
  Agmo = 146,
  Alfabank = 34,
  ApplePay = 188,
  Astropay = 67,
  AstropayWallet = 205,
  Awepay = 180,
  BPay = 98,
  Bancontact = 208,
  BankDirect = 82,
  BankWire = 87, //    GC_WIRE = 87,
  Banklinkswed = 60,
  BeMigration = 126,
  Bizum = 214,
  Boku = 136,
  BokuO2 = 140,
  BokuOrange = 141,
  BokuThreeUK = 138,
  BokuVodafone = 139,
  BoletoAstropay = 164,
  BoletoInovapay = 199,
  BugsyConversion = 121,
  CCoin = 75,
  CarteBleue = 115,
  CashFree = 174,
  CashFreeMobileWallet = 186,
  CashFreeNetBanking = 184,
  CashFreeUpi = 185,
  Cheque = 81,
  Citadel = 116,
  Click2Pay = 50,
  ClickNBuy = 110,
  CobroExpress = 94,
  CreditCard = 181,
  DBT = 105,
  Dankort = 53,
  DebitCard = 182,
  Dineromail = 56,
  Diners = 73,
  ECheck = 69,
  EPassporte = 80,
  EPay = 55,
  EcoPayZ = 170,
  ElvSepa = 150,
  Entropay = 79,
  EnvBaloto = 131,
  EnvoyLbt = 101,
  EnvoyRtbt = 118,
  Eps = 58,
  EsMigration = 43,
  Euteller = 62,
  FRMigration = 88,
  FirePay = 70,
  FullTilt = 125,
  FullTiltAssetMigr = 128,
  GamersCard = 179,
  Giropay = 49,
  GooglePay = 201,
  HiPay = 135,
  IDebit = 154,
  ITConversion = 71,
  Ideal = 57,
  InovapayHosted = 200,
  InstaDebit = 65,
  InstantBank = 37,
  Interac = 193,
  Klarna = 213,
  LoopBack = 76,
  LuxonPay = 212,
  MBWay = 207,
  MBookOBT = 35,
  MBookers = 66,
  MCTransfer = 102,
  MRMC = 68,
  ManualCredit = 99,
  ManualDebit = 100,
  MasterCard = 77,
  MgCashout = 103,
  Mir = 191,
  MobilePay = 204,
  MobilePayment = 130,
  MonetaCashout = 51,
  MoneyOrder = 111,
  Moneygram = 109,
  MoviPin = 129,
  MuchBetter = 175,
  Multibanco = 202,
  NemkontoCashout = 40,
  Neosurf = 163,
  NeosurfHosted = 210,
  NetBanking = 172,
  Neteller = 78,
  Neteller2 = 197,
  Nordea = 39,
  Now2PayMobile = 194,
  Now2PayWeb = 195,
  O2 = 64,
  OpenBanking = 211,
  Oxxo = 92,
  PSCash = 134,
  PSIOB = 152,
  PSPrepaid = 46,
  PSPrepaidCard = 44,
  PStarsPay = 120,
  PStarsPrepaid = 133,
  PStarsTopUp = 41,
  PagoEfectivo = 132,
  PagosOnline = 122,
  Pay4Fun = 196,
  Payconiq = 206,
  PayLucky = 151,
  PayMoney = 177,
  PayNearMe = 143,
  PayPal = 74,
  PaySafe = 112,
  PaysystemFee = 123,
  Paytm = 187,
  Pix = 209,
  ProfeeCards = 165,
  ProfeeMobilepayment = 168,
  ProfeeQiwi = 166,
  ProfeeWallet = 169,
  ProfeeYandex = 167,
  ProvinciaPagos = 93,
  PsPayAstropay = 148,
  PsPayInovapay = 198,
  Qiwi = 54,
  QiwiWallet = 36,
  RechargePS = 45,
  RechargePokerStars = 124,
  Resort = 144,
  Ricarica = 48,
  RipsaPagos = 95,
  Robokassa = 90,
  Rtbt = 114,
  SafetyPay = 147,
  SberBank = 155,
  SevenEleven = 91,
  Sightline = 159,
  SightlineNR = 160,
  Skrill1Tap = 203,
  Sofort = 59,
  Solo = 83,
  StarsVouchers = 158,
  StarsWallet = 171,
  Starscard = 61,
  Swish = 192,
  TMobile = 33,
  Tax = 145,
  TicketPremium = 104,
  Todito = 106,
  TransferIn = 84,
  TransferOut = 72,
  TrustPay = 38,
  UMWallet = 113,
  Ukash = 107,
  UpsellAward = 137,
  UseMyBank = 117,
  Vanilla = 153,
  VanillaDirect = 178,
  Visa = 86,
  VivaPayments = 156,
  Vodafone = 63,
  WUnion = 85,
  WalletOne = 42,
  WebMoney = 89,
  WireCashout = 119,
  WirecardWbt = 52,
  YandexMoney = 47
}
